<div fxLayout="column" fxLayoutGap="15px" class="change-regional-container">
  <div fxLayout="row">
    Wybierz, którego regionalnego chcesz zmienić
  </div>

  <div fxLayout="row" fxFlex="100">
    <mat-slide-toggle [formControl]="changeAssetsRegionalControl">Majątek</mat-slide-toggle>
  </div>

  <div fxLayout="row" fxFlex="100">
    <app-dict-regionals fxFlex="100" label="Nowy regionalny - majątek" [control]="assetsRegionalControl"></app-dict-regionals>
  </div>

  <div fxLayout="row" fxFlex="100">
    <mat-slide-toggle [formControl]="changeLifeRegionalControl">Życie</mat-slide-toggle>
  </div>

  <div fxLayout="row" fxFlex="100">
    <app-dict-regionals fxFlex="100" label="Nowy regionalny - życie" [control]="lifeRegionalControl"></app-dict-regionals>
  </div>

  <div fxLayout="row" fxFlex="100">
    <mat-slide-toggle [formControl]="changeOfwcaControl">Czy zmienic także u OFWCA, które mają ustawionego tego samego Regionalnego?</mat-slide-toggle>
  </div>

  <div fxLayout="row" fxFlex="100">
    <mat-slide-toggle [formControl]="changeOfwcaIfNotSameControl">Czy zmienić także u OFWCA, które mają ustawionego innego Regionalnego?</mat-slide-toggle>
  </div>

  <div fxLayout="row">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || (!assetsRegionalControl.value && !lifeRegionalControl.value)"
    >Zapisz</button>
  </div>
</div>
